<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-invest-icon01.svg" alt="*" />あなたの自己投資マインド
				</span>
			</div><!-- end .type -->
			<div class="cover">
				変革型{{investMindResult.percentageLeft}}%、保守型{{investMindResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>丁寧に自己投資するものを選び、1つの投資を長く行うタイプ</h2>
			<img src="../assets/result-detail-invest-inright01.svg" alt="*" class="visual" />
			<div class="caption">
				慎重さがゆえ、せっかくのチャンスをスルーしたり、1つの物事から損切して抜け出せない傾向も
			</div><!-- end .caption -->
			<p>2番目は自己投資の特性を診断しました。なぜなら、内向性の高い人ほど、自己投資で受けられるリターンが非常に大きくなる可能性を秘めているからです。</p>
			<p>内向的な人は外向的な人よりも、専門的に深く掘り下げることに適しています。また、自分を俯瞰して捉え、戦略を打つのも上手ですから、自己投資でより確実に成果を得る資質も備えています。</p>
			<p>あなたの自己投資は保守型{{investMindResult.percentageRight}}%という結果は、あなたの内向度{{levelResult.percentage}}%と掛け合わさり、非常に慎重に自分への投資を行う側面があります。丁寧に自己投資するものを選び、1つの投資を長く行うタイプと言えるでしょう。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->			
			<h2>内向性が高いからこそ、自己投資そのものが大きな投資であると認識する</h2>
			<img src="../assets/result-detail-invest-inright02.svg" alt="*" class="visual" />
			<div class="caption">
				程よく乱雑に、程よく丁寧に目の前のことに徹することで、多様な投資のリターンをきんと得られるようになる
			</div><!-- end .caption -->
			<p>内向性が高く、投資マインドが保守型の人は、人生の中で出会えるビックチャンスが少なりがちです。自己投資とは、自分に一気に変革を起こす機会とも言えます。</p>
			<p>保守的かつ内向的なので、やる前にあれこれと考えてしまうのです。やる理由よりも、やらない理由を見つける思考になると、自己投資をする機会そのものが少なくなります。</p>
			<p>内向型の人の最大の特長は、与えられた環境や状況に対して常に考えてしまう思考の癖です。だから、環境や状況の種類が多く、質が高いほど、あなたの思考の幅は一気に広がります。</p>
			<p>この点において、内向度が高いあなたには、本当の意味でまったく意味のない自己投資は存在しません。あなたは確実にリターンが返ってくるのです。</p>
			<p>内向性が高く、保守的なあなたのようなタイプこそ、自己投資そのものが大きな投資であると意識してください。この意識を顕在的に持つことで、あなたは程よく時に踏み出せるようになります。</p>
			<p>経験値が増えれば増えるほど、あなたの保守性は、見抜く力を確固たるものにします。見抜いているという確信があれば、行動を踏み切れるようになります。お金やリスクが必要ない場面でも、新しい感覚や初体験を積極的に取り入れるよういしてみて下さい。
			</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>どこまで執着するか、損切のポイントで、あなたの人生のお得感は決まる</h2>
			<img src="../assets/result-detail-invest-inright03.svg" alt="*" class="visual" />
			<div class="caption">
				安心感を得るための継続や執着になっていないかを常にチェックしていく
			</div><!-- end .caption -->
			<p>このタイプは、1つの自己投資に対して我慢強く、そして深く取り組むことができるため、良いものに投資できた際は、より確実にリターンを得ることができます。</p>
			<p>気を付けたいのは、「もったいない」という思考を持ち、例えばそれが意味のないものでも、すぐに止めることができない傾向がある点です。</p>
			<p>そのため、内向型で保守型の人は、1つの失敗が長く、そのダメージも大きい可能性が高くなります。何かに手を出すと、それにのめり込むことが安心感になり、そこから脱することが荷の重たい作業になるからです。</p>
			<p>単一的な自己投資にどっぶりハマるよりも、複数の場所やコミュニティへ分散させることが、内向性と保守性の高い人には向いているでしょう。分散させることで、１つの投資のコストやリスクも自然と低くなるはずです。様々な分野や人に触れる環境を作ることこそが、あなたの人生を豊かにする一番の自己投資と言えるでしょう。</p>
		</div><!-- end .sentence -->
</div><!-- end .contents -->				
</template>

<script>


export default {
	name: 'ResultDetailInvestInRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},			
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
